<template>
  <el-container class="InvoicePrintForm">
    <el-main ref="printInvoice" class="p-0">
      <h1 class="text-align-center">세 금 계 산 서</h1>

      <el-row>
        <el-col :span="12">
          <table class="table-customer">
            <tbody>
              <tr>
                <td class="bg-dark text-align-center" style="padding: 0 8px" rowspan="4">
                  공
                  <br />
                  <br />급
                  <br />
                  <br />자
                </td>

                <td class="bg-dark text-align-center">
                  <label class="label-company long">등 록 번 호</label>
                </td>
                <td colspan="3">{{currentCustomer.crn | crn}}</td>
              </tr>
              <tr>
                <td class="bg-dark text-align-center">
                  <label class="label-company long">상 호</label>
                </td>
                <td class="content-company">{{currentCustomer.name}}</td>
                <td class="bg-dark text-align-center">
                  <label class="label-company short">대표자명</label>
                </td>
                <td class="content-company text-align-center">{{currentCustomer.owner}}</td>
              </tr>
              <tr>
                <td class="bg-dark text-align-center">
                  <label class="label-company long">사 업 장 주 소</label>
                </td>
                <td colspan="3">{{currentCustomer.addr}}</td>
              </tr>
              <tr>
                <td class="bg-dark text-align-center">
                  <label class="label-company long">업 태</label>
                </td>
                <td class="text-align-center">{{currentCustomer.conditions}}</td>
                <td class="bg-dark text-align-center">
                  <label class="label-company short">종 목</label>
                </td>
                <td class="text-align-center">{{currentCustomer.item}}</td>
              </tr>
            </tbody>
          </table>
        </el-col>
        <el-col :span="12">
          <table class="table-company">
            <tbody>
              <tr>
                <td class="bg-dark text-align-center" style="padding: 0 8px" rowspan="4">
                  공
                  <br />급
                  <br />받
                  <br />는
                  <br />자
                </td>

                <td class="bg-dark text-align-center">
                  <label class="label-company long">등 록 번 호</label>
                </td>
                <td colspan="3">{{company.crn | crn}}</td>
              </tr>
              <tr>
                <td class="bg-dark text-align-center">
                  <label class="label-company long">상 호</label>
                </td>
                <td class="content-company">{{company.name}}</td>
                <td class="bg-dark text-align-center">
                  <label class="label-company short">대표자명</label>
                </td>
                <td class="content-company text-align-center">{{company.owner}}</td>
              </tr>
              <tr>
                <td class="bg-dark text-align-center">
                  <label class="label-company long">사 업 장 주 소</label>
                </td>
                <td colspan="3">{{company.addr}}</td>
              </tr>
              <tr>
                <td class="bg-dark text-align-center">
                  <label class="label-company long">업 태</label>
                </td>
                <td class="text-align-center">{{company.conditions}}</td>
                <td class="bg-dark text-align-center">
                  <label class="label-company short">종 목</label>
                </td>
                <td class="text-align-center">{{company.item}}</td>
              </tr>
            </tbody>
          </table>
        </el-col>
      </el-row>

      <el-row style="margin-top: 6px">
        <el-col :span="12">
          <table class="table-system">
            <thead>
              <tr>
                <th colspan="6">시스템 등록 세금계산서</th>
              </tr>
              <tr>
                <th>발행일자</th>
                <th>거래명세서 번호</th>
                <th>등록자</th>
                <th>공급가액</th>
                <th>세액</th>
                <th>금액</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="detail in details" :key="detail.id">
                <td class="text-align-center">{{detail.issue_date}}</td>
                <td class="text-align-center">{{detail.approval_number}}</td>
                <td class="text-align-center">{{detail.created_user_name}}</td>
                <td class="text-align-right">{{detail.supply_price | number}}</td>
                <td class="text-align-right">{{detail.tax | number}}</td>
                <td class="text-align-right">{{detail.price | number}}</td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td class="text-align-center" colspan="3">합계</td>
                <td
                  class="text-align-right"
                >{{details.reduce((sum, item) => sum + (item.supply_price ? item.supply_price : 0), 0) | number}}</td>
                <td
                  class="text-align-right"
                >{{details.reduce((sum, item) => sum + (item.tax ? item.tax : 0), 0) | number}}</td>
                <td
                  class="text-align-right"
                >{{details.reduce((sum, item) => sum + item.price, 0) | number}}</td>
              </tr>
            </tfoot>
          </table>
        </el-col>
        <el-col :span="12">
          <table class="table-invoice">
            <thead>
              <tr>
                <th colspan="6">국세청 등록 세금계산서</th>
              </tr>
              <tr>
                <th>발행일자</th>
                <th>거래명세서 번호</th>
                <th>등록자</th>
                <th>공급가액</th>
                <th>세액</th>
                <th>금액</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="detail in detailsInvoice" :key="detail.id">
                <td class="text-align-center">{{detail[2]}}</td>
                <td class="text-align-center">{{detail[1]}}</td>
                <td class="text-align-center">{{detail[11]}}</td>
                <td class="text-align-right">{{detail[15] | number}}</td>
                <td class="text-align-right">{{detail[16] | number}}</td>
                <td class="text-align-right">{{detail[14] | number}}</td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td class="text-align-center" colspan="3">합계</td>
                <td
                  class="text-align-right"
                >{{detailsInvoice.reduce((sum, item) => sum + item[15], 0) | number}}</td>
                <td
                  class="text-align-right"
                >{{detailsInvoice.reduce((sum, item) => sum + item[16], 0) | number}}</td>
                <td
                  class="text-align-right"
                >{{detailsInvoice.reduce((sum, item) => sum + item[14], 0) | number}}</td>
              </tr>
            </tfoot>
          </table>
        </el-col>
      </el-row>

      <el-row type="flex" justify="space-between" style="margin-top: 6px">
        <span class="text-color-red">{{$t('lang.software_consulting')}}</span>
        <span class="text-color-red">{{$t('lang.homepage')}}</span>
      </el-row>
    </el-main>

    <el-footer>
      <el-button type="primary" @click="clickPrint">세금계산서 출력</el-button>
      <!--<el-button type="primary" @click="clickPrint">국세청 엑셀 가져오기</el-button>-->
      <el-upload
        ref="upload"
        style="display: inline-block; margin-left: 10px;"
        action="/"
        :show-file-list="false"
        :on-change="importExcel"
        :auto-upload="false"
      >
        <el-button slot="trigger" size="small" type="primary">국세청 엑셀 가져오기</el-button>
      </el-upload>

      <el-button class="right" @click="closeDialog">{{$t('button.close')}} (Esc)</el-button>
    </el-footer>
  </el-container>
</template>

<script>
import { form } from "@/common/mixins/form";
import { mapGetters } from "vuex";
import Vue from "vue";
import { company_info } from "@/common/mixins/company_info";
import Print from "../../plugins/print/print";
import XLSX from "xlsx";

Vue.use(Print);

export default {
  name: "InvoicePrintForm",
  mixins: [form, company_info],
  components: {},
  data() {
    return {
      currentCustomer: {},
      detailsInvoice: []
    };
  },
  props: {
    data: {
      type: Object,
      required: true
    },
    details: {
      type: Array,
      required: true
    }
  },
  computed: {
    ...mapGetters(["table_customer"])
  },
  mounted() {
    this.loadCustomer();
    this.loadConfig();
  },
  methods: {
    loadCustomer() {
      this.currentCustomer = this.table_customer.find(item => item.id === this.data.id);
    },
    /** 출력 */
    clickPrint() {
      this.$print(this.$refs.printInvoice);
    },
    importExcel(file) {
      // let file = file.files[0] // 使用传统的input方法需要加上这一步
      const types = file.name.split(".")[1];
      const fileType = ["xlsx", "xlc", "xlm", "xls", "xlt", "xlw", "csv"].some(
        item => item === types
      );
      if (!fileType) {
        this.$message("파일형식이 맞지 않습니다.");
        return;
      }
      this.file2Xce(file).then(tabJson => {
        if (tabJson && tabJson.length > 0) {
          let approvalNumbers = this.details.map(item => item.approval_number);
          let data = tabJson.slice(6);
          data = data.filter(item => {
            return approvalNumbers.includes(item[1]);
          });
          this.detailsInvoice = data;
        }
      });
    },
    file2Xce(file) {
      return new Promise(function(resolve /*, reject*/) {
        const reader = new FileReader();
        reader.onload = function(e) {
          const data = e.target.result;
          this.wb = XLSX.read(data, {
            type: "binary"
          });
          let result = [];
          result = XLSX.utils.sheet_to_json(this.wb.Sheets["세금계산서"], {
            header: 1
          });
          // this.wb.SheetNames.forEach((sheetName) => {
          //
          //     // result.push({
          //     //     sheetName: sheetName,
          //     //     sheet: XLSX.utils.sheet_to_json(this.wb.Sheets[sheetName], {header:1})
          //     // })
          // })
          resolve(result);
        };
        reader.readAsBinaryString(file.raw);
        // reader.readAsBinaryString(file)
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/_variables.scss";

.el-dialog__body .el-main {
  height: unset;
}

.text-align-right {
  text-align: right;
}

.text-align-center {
  text-align: center;
}

.text-color-red {
  color: red;
}

$padding-td: 4px 4px;

.table-customer {
  width: 100%;
  border-collapse: collapse;
  border-color: $color-border-print-table;
  border-style: solid;
  border-width: 2px 1px 2px 2px;

  td {
    padding: $padding-td;
    border: 1px solid $color-border-print-table;
  }
}

.table-company {
  width: 100%;
  border-collapse: collapse;
  border-color: $color-border-print-table;
  border-style: solid;
  border-width: 2px 2px 2px 1px;

  td {
    padding: $padding-td;
    border: 1px solid $color-border-print-table;
  }
}

.table-system {
  width: 100%;
  border-collapse: collapse;
  border-color: $color-border-print-table;
  border-style: solid;
  border-width: 2px 1px 2px 2px;

  th {
    border: 1px solid $color-border-print-table;
    background-color: $color-bg-print-table-header;
    padding: 2px 0;
  }

  td {
    padding: $padding-td;
    border: 1px solid $color-border-print-table;
  }
}

.table-invoice {
  width: 100%;
  border-collapse: collapse;
  border-color: $color-border-print-table;
  border-style: solid;
  border-width: 2px 2px 2px 1px;

  th {
    border: 1px solid $color-border-print-table;
    background-color: $color-bg-print-table-header;
    padding: 2px 0;
  }

  td {
    padding: $padding-td;
    border: 1px solid $color-border-print-table;
  }
}

.label-customer {
  display: inline-block;
  width: 80px;
  text-align: justify;
  text-align-last: justify;
  margin-right: 10px;
}

.label-customer:after {
  display: inline-block;
  content: none;
  width: 100%;
}

.content-customer {
  width: 50%;
  color: red;
}

.bg-dark {
  background-color: $color-bg-print-table-header !important;
}

.label-company {
  display: inline-block;
  text-align: justify;
  text-align-last: justify;

  &.long {
    width: 108px;
  }

  &.short {
    width: 64px;
  }
}

.label-company:after {
  display: inline-block;
  content: none;
  width: 100%;
}

.content-company {
  width: 50%;
}
</style>